import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	searchPlaceholderText: {
		id: 'eoc.heartbeats.filter.search-placeholder-text.no-translate',
		defaultMessage: 'Search heartbeats',
		description: 'Placeholder text of a search text field.',
	},
	statusLabel: {
		id: 'eoc.heartbeats.filter.filter-placeholder-text.no-translate',
		defaultMessage: 'Status',
		description: 'Label text of a status dropdown field.',
	},
	statusAriaLabel: {
		id: 'eoc.heartbeats.filter.filter-placeholder-text.no-translate',
		defaultMessage: 'Select status',
		description: 'Aria label text of a status dropdown field.',
	},
});

export default messages;
